import React from 'react';
import MenuItems from '../MenuItems/MenuItems';
export default function MenuPage() {
  return (
    <>
      <MenuItems />
    </>
  );
}
